import React, { useState, useEffect } from "react"
import { useGlobalContext } from "../data/GlobalContext"
import { Helmet } from "react-helmet"
import { currentDomain, currentPath } from "../Index"
import { promotionsData } from "../data/PromotionData"
import MasterGamesList from "../data/MasterGamesList"
import ModuleFaChaiGrandSpinAle from "./promotion_modules/modules_fcGrandSpinAle"

export default function FCGrandSpinAle() {
  const [activeModal, setActiveModal] = useState("")

  const modalComponents = {
    "FC Grand Spin-Ale": ModuleFaChaiGrandSpinAle,
  }

  const ActiveModal = activeModal ? modalComponents[activeModal] : null
  const data = promotionsData.find(
    (promo) => promo.title === "FC Grand Spin-Ale"
  )
  const [isMobile, setIsMobile] = useState(false)
  const [isLoggedIn, setIsLoggedIn] = useState(false)

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 841)
    }
    handleResize()
    window.addEventListener("resize", handleResize)
    return () => {
      window.removeEventListener("resize", handleResize)
    }
  }, [])

  useEffect(() => {
    const loggedInState = localStorage.getItem("isLoggedIn") === "true"
    setIsLoggedIn(loggedInState)
  }, [])

  const handleFaChaiGrandSpinAle = () => {
    if (!isLoggedIn) {
      window.location.href = "/promotion"
    } else {
      setActiveModal("FC Grand Spin-Ale")
    }
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>FA CHAI X FGH Grand Spin-Ale</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>
      <div className="promotion-page-main all-page-main-container-min-height">
        <div className="promotion-page-container main-container-global-adjusted-padding">
          <div className="promotion-tnc-page">
            <div className="promotion-page-breadcrumb">
              <a href="/promotion/">Promotions </a> / <span>{data.title}</span>
            </div>
            <div className="promotion-tnc-banner">
              <img
                src={isMobile ? data.imgSrc : data.bannerSrc}
                alt={`FGH ${data.title}`}
              />

              <div className="promotion-tnc-content">
                <div className="promotion-tnc-info">
                  <div
                    className={`promotion-indication-message ${data.promotionMessage.class}`}
                  >
                    {data.promotionMessage.text}
                  </div>
                  <h1>FC GRAND SPIN-ALE</h1>
                  <h2>October's biggest spin celebration is here!</h2>
                  <div className="promotion-tnc-period">
                    <strong>Promo Period: </strong>
                    <span>October 1, 12PM - October 31, 11:59AM 2025</span>
                  </div>

                  <div className="promotion-tnc-mechanic-content">
                    {isLoggedIn && data.title === "FC Grand Spin-Ale" && (
                      <div className="promotion-tnc-btn-wrapper">
                        <button
                          className="promotion-cta-btn"
                          onClick={handleFaChaiGrandSpinAle}
                        >
                          Leaderboard
                        </button>
                      </div>
                    )}
                    <strong> Terms & Conditions </strong>{" "}
                    <ol>
                      <li>
                        <strong className="highlight">How to Join</strong>
                        <p>
                          ☑️ Play any FACHAI Slot Games during the promo period.
                        </p>
                        <p>
                          ☑️ Accumulate at least 15,000 turnover to qualify.
                        </p>
                      </li>

                      <li>
                        <strong className="highlight">
                          Leaderboard Rewards
                        </strong>
                        <p>
                          ☑️ Top 30 players with highest total turnover will win
                          Fachai Free Spins below:
                        </p>
                      </li>

                      <div className="table-wrapper">
                        <table
                          className="promotion-tnc-table"
                          style={{ minWidth: "100px" }}
                        >
                          <thead>
                            <th>Rank</th>
                            <th>Free Spins per Player</th>
                            <th>Total Spins</th>
                          </thead>
                          <tbody>
                            <tr>
                              <td>1</td>
                              <td>600</td>
                              <td>600</td>
                            </tr>
                            <tr>
                              <td>2</td>
                              <td>350</td>
                              <td>350</td>
                            </tr>
                            <tr>
                              <td>3</td>
                              <td>250</td>
                              <td>250</td>
                            </tr>
                            <tr>
                              <td>4-10</td>
                              <td>200</td>
                              <td>1,400</td>
                            </tr>
                            <tr>
                              <td>11-20</td>
                              <td>150</td>
                              <td>1,500</td>
                            </tr>
                            <tr>
                              <td>21-30</td>
                              <td>100</td>
                              <td>1,000</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <li>
                        <strong className="highlight">
                          Free spins Bet Value:
                        </strong>
                        <p>☑️ (Based on VIP Level)</p>
                      </li>
                      <div className="table-wrapper">
                        <table
                          className="promotion-tnc-table"
                          style={{ minWidth: "100px" }}
                        >
                          <thead>
                            <th>VIP Level</th>
                            <th>Bet Value</th>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Alexandrite</td>
                              <td>₱24.00</td>
                            </tr>
                            <tr>
                              <td>Diamond</td>
                              <td>₱12.00</td>
                            </tr>
                            <tr>
                              <td>Ruby</td>
                              <td>₱6.00</td>
                            </tr>
                            <tr>
                              <td>Sapphire</td>
                              <td>₱3.60</td>
                            </tr>
                            <tr>
                              <td>Emerald</td>
                              <td>₱2.40</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <li>
                        <strong className="highlight">
                          Schedule of Awarding of TOP 30:
                        </strong>
                        <p>☑️ (October 31, 2025 - 2PM)</p>
                        <p>
                          Note: Free Spins can be used on: Chinese New Year 2,
                          Jungle Bang Bang, Chinese New Year Moreways / No
                          rollover requirement
                        </p>
                      </li>
                      <strong>Qualified Games</strong>
                      <MasterGamesList
                        fachaiGamesOnly="on"
                        customWrapperClass="gameListWrapper promotion-signup-game-list"
                        customFaChaiGames={[
                          {
                            provider: "fachai",
                            gameName: "CHINESE NEW YEAR 2",
                          },
                          { provider: "fachai", gameName: "JUNGLE BANG BANG" },
                          {
                            provider: "fachai",
                            gameName: "CHINESE NEW YEAR MOREWAYS",
                          },
                        ]}
                        rank="off"
                        limit={5}
                        headerText={null}
                        linkTo={null}
                        headerTag="h2"
                      />
                      <li>
                        <strong className="highlight">
                          Additional Ways to Earn Free Spins
                        </strong>
                        <p>
                          ☑️ Reach 5,000 weekly turnover to get 20 Free Spins
                        </p>
                        <p>☑️ (Cut-off: Friday 12:00 NN – Friday 11:59 AM)</p>
                        <p>
                          ☑️ Free Spins (₱6 bet value) credited every Friday at
                          3:00 PM without rollover requirement!
                        </p>
                      </li>
                      <div className="table-wrapper">
                        <table
                          className="promotion-tnc-table"
                          style={{ minWidth: "100px" }}
                        >
                          <thead>
                            <th>Date Range</th>
                            <th>Weekly Awarding</th>
                          </thead>
                          <tbody>
                            <tr>
                              <td>October 3-10</td>
                              <td>October 10, 15:00</td>
                            </tr>
                            <tr>
                              <td>October 10-17</td>
                              <td>October 17, 15:00</td>
                            </tr>
                            <tr>
                              <td>October 17-24</td>
                              <td>October 24, 15:00</td>
                            </tr>
                            <tr>
                              <td>October 24-31</td>
                              <td>October 31, 15:00</td>
                            </tr>
                            <tr>
                              <td>Date Range</td>
                              <td>Weekly Awarding</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <li>
                        <strong className="highlight">
                          FGH Management reserves the right to modify or cancel
                          this promo at any time.
                        </strong>
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {ActiveModal && <ActiveModal closeModal={() => setActiveModal(null)} />}
    </>
  )
}
